import {
  convertMultiValueToTagsValue,
  convertTagsValueToMultiValue,
} from '../../../../../../../DynamicTagsInputs/utils';

export const useTagSelection = (value, onChange) => {
  const handleTagSelection = ({ tag, tagType }) => {
    const prev = convertTagsValueToMultiValue(value[tagType]);
    const currentValue = prev?.length > 0 ? [...prev] : [];
    
    const isSelected = currentValue.some(d => d.value === tag.value);
    const newValue = isSelected 
      ? currentValue.filter(d => d.value !== tag.value)
      : [...currentValue, tag];

    onChange(tagType, convertMultiValueToTagsValue(tagType, newValue));
  };

  const getSelectionCount = (tagType) => value[tagType]?.data?.length || 0;

  const getListProps = ({ 
    options, 
    itemType, 
    isMulti = false, 
    iconAfter, 
    icon, 
    valueProp,
    onItemClick
  }) => ({
    options: options?.map(item => ({ ...item, icon })),
    onChange: (id, item) => onItemClick({ item, itemType }),
    isMulti,
    isSearchable: false,
    disableShadow: true,
    enableBorder: false,
    alignCheckbox: 'right',
    iconAfter,
    ...(isMulti && { value: convertTagsValueToMultiValue(value.tags) }),
    ...(!isMulti && valueProp ? { value: valueProp } : {})
  });

  return {
    handleTagSelection,
    getSelectionCount,
    getListProps,
  };
};
